package music.jammers.client.shared.event.di

import music.jammers.client.shared.analytics.event.EventAnalytics
import music.jammers.client.shared.analytics.event.EventAnalyticsImpl
import music.jammers.client.shared.analytics.event.EventTrackAnalytics
import music.jammers.client.shared.analytics.event.EventTrackAnalyticsImpl
import music.jammers.client.shared.event.data.repository.EventRepositoryImpl
import music.jammers.client.shared.event.domain.repository.EventRepository
import music.jammers.client.shared.event.domain.usecase.GetUserAcceptanceUseCase
import music.jammers.client.shared.event.domain.usecase.ValidateEventUseCase
import music.jammers.client.shared.event.domain.validator.EventFieldValidator
import music.jammers.client.shared.event.presentation.mapper.EventListItemMapper
import music.jammers.client.shared.event.presentation.viewmodel.CreateEventViewModel
import music.jammers.client.shared.event.presentation.viewmodel.EditEventViewModel
import music.jammers.client.shared.event.presentation.viewmodel.EventDetailsViewModel
import music.jammers.client.shared.event.presentation.viewmodel.EventListViewModel
import music.jammers.client.shared.event.track.domain.usecase.SignInTrackUseCase
import music.jammers.client.shared.event.track.domain.usecase.SignOutTrackUseCase
import music.limasoul.client.shared.event.domain.usecase.CreateEventUseCase
import music.limasoul.client.shared.event.domain.usecase.DeleteEventUseCase
import music.limasoul.client.shared.event.domain.usecase.FreezeEventUseCase
import music.limasoul.client.shared.event.domain.usecase.GetEventDetailsUseCase
import music.limasoul.client.shared.event.domain.usecase.GetEventUseCase
import music.limasoul.client.shared.event.domain.usecase.LoadEventsUseCase
import music.limasoul.client.shared.event.domain.usecase.SortEventTrackUseCase
import music.limasoul.client.shared.event.domain.usecase.UpdateEventUseCase
import music.limasoul.client.shared.event.presentation.viewmodel.EventFreezeViewModel
import org.koin.core.component.KoinComponent
import org.koin.dsl.module

val eventModule = module {
    factory {
        CreateEventViewModel(
            validateEventUseCase = get(),
            createEventUseCase = get(),
            eventAnalytics = get(),
            eventFieldValidator = get(),
            router = get(),
        )
    }

    factory {
        EditEventViewModel(
            validateEventUseCase = get(),
            getEventUseCase = get(),
            updateEventUseCase = get(),
            deleteEventUseCase = get(),
            eventFieldValidator = get(),
            eventAnalytics = get(),
            router = get(),
        )
    }

    factory {
        ValidateEventUseCase(
            eventFieldValidator = get(),
        )
    }

    factory {
        CreateEventUseCase(
            eventRepository = get(),
        )
    }

    factory {
        GetEventUseCase(
            eventRepository = get(),
        )
    }

    factory {
        UpdateEventUseCase(
            eventRepository = get(),
        )
    }

    factory {
        DeleteEventUseCase(
            eventRepository = get(),
        )
    }

    factory {
        EventDetailsViewModel(
            getEventDetailsUseCase = get(),
            signInTrackUseCase = get(),
            signOutTrackUseCase = get(),
            getCurrentUserUseCase = get(),
            getUserAcceptanceUseCase = get(),
            eventAnalytics = get(),
            router = get(),
        )
    }

    factory {
        EventFreezeViewModel(
            freezeEventUseCase = get(),
            getEventDetailsUseCase = get(),
            sortEventTracksUseCase = get(),
            router = get(),
        )
    }

    factory {
        GetEventDetailsUseCase(
            eventRepository = get(),
        )
    }

    factory {
        FreezeEventUseCase(
            eventRepository = get(),
        )
    }

    factory {
        SortEventTrackUseCase(
            eventRepository = get(),
        )
    }

    factory {
        SignInTrackUseCase(
            eventTrackRepository = get(),
        )
    }

    factory {
        GetUserAcceptanceUseCase(
            eventRepository = get(),
        )
    }

    factory {
        SignOutTrackUseCase(
            eventTrackRepository = get(),
        )
    }

    factory {
        EventListViewModel(
            loadEventsUseCase = get(),
            getCurrentUserUseCase = get(),
            eventAnalytics = get(),
            eventListItemMapper = get(),
            router = get(),
        )
    }

    single {
        EventFieldValidator()
    }

    single {
        EventListItemMapper()
    }

    single<EventAnalytics> {
        EventAnalyticsImpl(
            firebaseAnalytics = get(),
        )
    }

    single<EventTrackAnalytics> {
        EventTrackAnalyticsImpl(
            firebaseAnalytics = get(),
        )
    }
    single {
        LoadEventsUseCase(
            repository = get()
        )
    }

    single<EventRepository> {
        EventRepositoryImpl(
            client = get()
        )
    }
}

object EventComponent : KoinComponent {

    val createEventViewModel: CreateEventViewModel
        get() = getKoin().get<CreateEventViewModel>()

    val editEventViewModel: EditEventViewModel
        get() = getKoin().get<EditEventViewModel>()

    val eventDetailViewModel: EventDetailsViewModel
        get() = getKoin().get<EventDetailsViewModel>()

    val eventListViewModel: EventListViewModel
        get() = getKoin().get<EventListViewModel>()

    val eventFreezeViewModel: EventFreezeViewModel
        get() = getKoin().get<EventFreezeViewModel>()
}